module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("产品列表")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('scroller', {
    ref: "scroller"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      class: _vm.getClazz(index),
      on: {
        "click": function($event) {
          _vm.onItemClick(index)
        }
      }
    }, [_c('h1', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "item-section"
    }, [_vm._v(_vm._s(item.summary))]), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_vm._v(_vm._s(item.remark))]), _vm._v(" "), _c('div', {
      staticClass: "triangle"
    })])
  }))]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50b23de8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/borrow/explain.vue
// module id = 353
// module chunks = 1